import { get } from "../../utils/objectHelpers";

<if(input)>
    $ {
        const heading = get(input, "title", "");
        const announcement = get(input, "announcement", []);
        const learnMore = get(input, "learnMore", null);
        const dismiss = get(input, "dismiss", null);
        const dismissText = get(dismiss, "textSpans.0.text", "");
    }

    <ebay-lightbox-dialog
      a11y-close-text=dismissText
      open=state.open
      class="str-seller-comms"
      on-close("closeDialog")>
      <@header><str-textual-display ...heading /></@header>
      <str-textual-display
        ...announcement
        wrapper="section"
        target="_blank"
        allowHtml=true
        class="str-seller-comms__announcement"
      />
      <@footer>
        <if(dismiss)>
            $ {
                const dismissLabel = get(dismiss, "textSpans", []);
                const dismissTracking = JSON.stringify(get(dismiss, "action.trackingList.0", get(dismiss, "action.tracking", {})));
            }
            <ebay-button priority="secondary" class="default-btn" data-track=dismissTracking on-click("closeDialog")>
                <str-textual-display textSpans=dismissLabel />
            </ebay-button>
        </if>
        <if(learnMore)>
            $ {
                const learnMoreLabel = get(learnMore, "textSpans", []);
                const learnMoreUrl = get(learnMore, "action.URL", null);
                const learnMoreTracking = JSON.stringify(get(learnMore, "action.trackingList.0", get(learnMore, "action.tracking", {})));
            }
            <ebay-button priority="primary" class="default-btn" href=learnMoreUrl data-track=learnMoreTracking target="_blank" >
                <str-textual-display textSpans=learnMoreLabel />
            </ebay-button>
        </if>
      </@footer>
    </ebay-lightbox-dialog>
</if>
